import React, { useState, useContext, useEffect } from 'react'
import FeedbackContext from '../Context/FeedbackContext'
import Card from './shared/Card'
import Button from './shared/Button'
import RatingSelect from './RatingSelect'

function FeedbackForm() {

    const [text, setText] = useState('')

    const [rating, setRating] = useState(1)

    const [btnDisabled, setBtnDisabled] = useState(true)

    const [message, setMessage] = useState('')

    const { addFeedback, feedbackEdit } = useContext(FeedbackContext)

    useEffect(() => {
        if (feedbackEdit.edit === true) {
            setBtnDisabled(false)
            setText(feedbackEdit.item.text)
            setRating(feedbackEdit.item.rating)
        }
    }, [feedbackEdit])

    const handleTextChange = (e) => {
        if (text === '') {
            setBtnDisabled(true)
            setMessage(null)
        } else if (text !== " " && text.trim().length <= 10) {
            setMessage('text must  be atleast 10 characters')
            setBtnDisabled(true)
        } else {
            setBtnDisabled(false)
            setMessage(null)
        }
        setText(e.target.value)
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (text.trim().length > 10) {
            const newFeedback = {
                text,
                rating
            }
            addFeedback(newFeedback);
            setText('');
        }
    }

    return (
        <Card>
            <form onSubmit={handleSubmit}>
                <h2> How would you  rate your service with us ?</h2>
                <RatingSelect select={(rating) => setRating(rating)}></RatingSelect>
                <div className='input-group'>
                    <input onChange={handleTextChange} type="text" placeholder="Write a Reivew" value={text} />
                    <Button type="submit" isDisabled={btnDisabled}>Send</Button>
                </div>
                {message && <div className='message'>{message} </div>}
            </form>

        </Card>
    )
}

export default FeedbackForm
